import { Injectable } from '@angular/core';
import { Appointment, Fitter } from '@sc/data-access-models';
import { ConfigurationService } from './configuration.service';
import { dayjs } from '@sc/utils';

@Injectable({
  providedIn: 'root',
})
export class TimezoneService {
  constructor(private readonly configService: ConfigurationService) {}

  getDefaultTimezone(): string {
    return this.configService.getConfig().uniqueTimezone ?? 'Etc/UTC';
  }

  getTimezone(appointment?: Appointment) {
    return appointment?.timezone
      ? appointment.timezone
      : this.getDefaultTimezone();
  }

  getFitterTimezone(fitter?: Fitter) {
    return fitter?.timezone ? fitter.timezone : this.getDefaultTimezone();
  }

  getFitterListTimezone(...fitters: Fitter[]) {
    const defaultTimezone = this.getDefaultTimezone();
    let allFittersSameTz = true;
    let sameTimezone: string = null;
    for (const f of fitters) {
      if (!sameTimezone) {
        sameTimezone = f.timezone;
      }

      if (sameTimezone !== f.timezone) {
        allFittersSameTz = false;
      }
    }

    return allFittersSameTz && sameTimezone ? sameTimezone : defaultTimezone;
  }

  getExcelLocalDateTimeFormat(date: string | Date, timezone: string): Date {
    const d = dayjs(date).tz(timezone);

    // Force date conversion to UTC date to avoid timezone issues when exporting to Excel
    return new Date(
      Date.UTC(
        d.year(),
        d.month(),
        d.date(),
        d.hour(),
        d.minute(),
        d.second(),
        d.millisecond()
      )
    );
  }
}
